"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactToastify = require("react-toastify");

var _styled = require("./styled");

var _helpers = require("./helpers");

var _hooks = require("../../hooks");

var _reactHooks = require("@trycourier/react-hooks");

var _reactProvider = require("@trycourier/react-provider");

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _deepExtend = _interopRequireDefault(require("deep-extend"));

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _constants = require("../../constants");

var _core = require("@trycourier/core");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var containerStyles = {
  height: "100%",
  padding: "0 12px"
};

var ClickableContainer = _styledComponents["default"].a.withConfig({
  displayName: "Body__ClickableContainer",
  componentId: "sc-149aoo9-0"
})(function (_ref) {
  var _theme$brand, _theme$brand$colors, _theme$brand$inapp$to, _theme$brand2, _theme$brand2$inapp, _theme$brand2$inapp$t, _theme$message, _theme$message2;

  var theme = _ref.theme;
  var primaryColor = (_theme$brand = theme.brand) === null || _theme$brand === void 0 ? void 0 : (_theme$brand$colors = _theme$brand.colors) === null || _theme$brand$colors === void 0 ? void 0 : _theme$brand$colors.primary;
  var tcPrimaryColor = (0, _tinycolor["default"])(primaryColor);
  return (0, _deepExtend["default"])(_objectSpread(_objectSpread({}, containerStyles), {}, {
    display: "flex",
    "*, &": {
      "text-decoration": "none"
    },
    "&:hover": {
      background: tcPrimaryColor.setAlpha(0.14)
    },
    cursor: "pointer",
    borderRadius: (_theme$brand$inapp$to = (_theme$brand2 = theme.brand) === null || _theme$brand2 === void 0 ? void 0 : (_theme$brand2$inapp = _theme$brand2.inapp) === null || _theme$brand2$inapp === void 0 ? void 0 : (_theme$brand2$inapp$t = _theme$brand2$inapp.toast) === null || _theme$brand2$inapp$t === void 0 ? void 0 : _theme$brand2$inapp$t.borderRadius) !== null && _theme$brand$inapp$to !== void 0 ? _theme$brand$inapp$to : _constants.themeDefaults.inapp.toast.borderRadius
  }), (_theme$message = theme.message) === null || _theme$message === void 0 ? void 0 : _theme$message.container, theme === null || theme === void 0 ? void 0 : (_theme$message2 = theme.message) === null || _theme$message2 === void 0 ? void 0 : _theme$message2.clickableContainer);
});

var NonClickableContainer = _styledComponents["default"].div.withConfig({
  displayName: "Body__NonClickableContainer",
  componentId: "sc-149aoo9-1"
})(function (_ref2) {
  var _theme$brand$inapp$to2, _theme$brand3, _theme$brand3$inapp, _theme$brand3$inapp$t, _theme$message$contai, _theme$message3;

  var theme = _ref2.theme;
  return (0, _deepExtend["default"])(_objectSpread(_objectSpread({}, containerStyles), {}, {
    display: "flex",
    borderRadius: (_theme$brand$inapp$to2 = (_theme$brand3 = theme.brand) === null || _theme$brand3 === void 0 ? void 0 : (_theme$brand3$inapp = _theme$brand3.inapp) === null || _theme$brand3$inapp === void 0 ? void 0 : (_theme$brand3$inapp$t = _theme$brand3$inapp.toast) === null || _theme$brand3$inapp$t === void 0 ? void 0 : _theme$brand3$inapp$t.borderRadius) !== null && _theme$brand$inapp$to2 !== void 0 ? _theme$brand$inapp$to2 : _constants.themeDefaults.inapp.toast.borderRadius
  }), (_theme$message$contai = (_theme$message3 = theme.message) === null || _theme$message3 === void 0 ? void 0 : _theme$message3.container) !== null && _theme$message$contai !== void 0 ? _theme$message$contai : {});
});

var Body = function Body(_ref3) {
  var _message$title, _message$preview, _message$icon, _config$brand, _brand$inapp, _ref4, _brand$inapp2, _brand$inapp2$icons;

  var message = _ref3.message,
      onClick = _ref3.onClick,
      title = _ref3.title,
      preview = _ref3.preview,
      icon = _ref3.icon,
      markdownOptions = _ref3.markdownOptions,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["message", "onClick", "title", "preview", "icon", "markdownOptions"]);
  var actions = message.actions,
      data = message.data,
      messageId = message.messageId;
  title = (_message$title = message.title) !== null && _message$title !== void 0 ? _message$title : title;
  preview = (_message$preview = message.preview) !== null && _message$preview !== void 0 ? _message$preview : preview;
  icon = (_message$icon = message.icon) !== null && _message$icon !== void 0 ? _message$icon : icon;

  var _useToast = (0, _hooks.useToast)(),
      _useToast2 = (0, _slicedToArray2["default"])(_useToast, 2),
      config = _useToast2[1].config;

  var courier = (0, _reactProvider.useCourier)();
  var courierBrand = courier.brand;
  var brand = (_config$brand = config === null || config === void 0 ? void 0 : config.brand) !== null && _config$brand !== void 0 ? _config$brand : courierBrand;
  var toastProps = props.toastProps;

  var _useInbox = (0, _reactHooks.useInbox)(),
      markMessageRead = _useInbox.markMessageRead,
      trackClick = _useInbox.trackClick;

  var openLinksInNewTab = config.openLinksInNewTab;
  var handleOnClickDismiss = (0, _react.useCallback)(function () {
    return _reactToastify.toast.dismiss(toastProps === null || toastProps === void 0 ? void 0 : toastProps.toastId);
  }, [toastProps === null || toastProps === void 0 ? void 0 : toastProps.toastId]);
  var Icon = (0, _helpers.getIcon)(
  /* priority:
    1. from message
    2. from props.defaultIcon
    3. from props.brand.inapp.icons.message
    4. from remote brand.inapp.icons.message
  */
  brand !== null && brand !== void 0 && (_brand$inapp = brand.inapp) !== null && _brand$inapp !== void 0 && _brand$inapp.disableMessageIcon ? false : (_ref4 = icon || (config === null || config === void 0 ? void 0 : config.defaultIcon)) !== null && _ref4 !== void 0 ? _ref4 : brand === null || brand === void 0 ? void 0 : (_brand$inapp2 = brand.inapp) === null || _brand$inapp2 === void 0 ? void 0 : (_brand$inapp2$icons = _brand$inapp2.icons) === null || _brand$inapp2$icons === void 0 ? void 0 : _brand$inapp2$icons.message);
  var clickActionDetails = (0, _react.useMemo)(function () {
    var _actions$0$data;

    if (data !== null && data !== void 0 && data.clickAction) {
      return {
        href: data.clickAction
      };
    }

    if (!(actions !== null && actions !== void 0 && actions.length) || actions.length > 1) {
      return;
    }

    return {
      trackingId: (_actions$0$data = actions[0].data) === null || _actions$0$data === void 0 ? void 0 : _actions$0$data.trackingId,
      href: actions[0].href
    };
  }, [data === null || data === void 0 ? void 0 : data.clickAction, actions]);
  var containerProps = {};

  if (clickActionDetails !== null && clickActionDetails !== void 0 && clickActionDetails.href) {
    containerProps.href = clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href;

    if (openLinksInNewTab) {
      containerProps = _objectSpread(_objectSpread({}, containerProps), {}, {
        target: "_blank",
        rel: "noreferrer"
      });
    }

    containerProps.onClick = /*#__PURE__*/function () {
      var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(event) {
        var promises;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();

                if (!messageId) {
                  _context.next = 6;
                  break;
                }

                promises = [markMessageRead(messageId), (clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.trackingId) && trackClick(messageId, clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.trackingId)].filter(Boolean);

                if (!promises.length) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return Promise.all(promises);

              case 6:
                if (!onClick) {
                  _context.next = 9;
                  break;
                }

                onClick(event);
                return _context.abrupt("return");

              case 9:
                if (!courier.onRouteChange) {
                  _context.next = 12;
                  break;
                }

                courier.onRouteChange(clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href, message);
                return _context.abrupt("return");

              case 12:
                if (openLinksInNewTab) {
                  window.open(clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href, "_blank");
                } else {
                  window.location.href = clickActionDetails === null || clickActionDetails === void 0 ? void 0 : clickActionDetails.href;
                }

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }();
  }

  var renderedMessage = (0, _react.useMemo)(function () {
    var _actions$length, _actions$slice;

    var renderActionButtons = ((_actions$length = actions === null || actions === void 0 ? void 0 : actions.length) !== null && _actions$length !== void 0 ? _actions$length : 0) > 1;

    var handleActionClick = function handleActionClick(action) {
      return /*#__PURE__*/function () {
        var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(event) {
          var _action$data, _action$data2;

          var promises;
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  event.preventDefault();
                  promises = [messageId && markMessageRead(messageId), messageId && (action === null || action === void 0 ? void 0 : (_action$data = action.data) === null || _action$data === void 0 ? void 0 : _action$data.trackingId) && trackClick(messageId, action === null || action === void 0 ? void 0 : (_action$data2 = action.data) === null || _action$data2 === void 0 ? void 0 : _action$data2.trackingId)].filter(Boolean);

                  if (!promises.length) {
                    _context2.next = 5;
                    break;
                  }

                  _context2.next = 5;
                  return Promise.all(promises);

                case 5:
                  if (!courier.onRouteChange) {
                    _context2.next = 8;
                    break;
                  }

                  courier.onRouteChange(action === null || action === void 0 ? void 0 : action.href, message);
                  return _context2.abrupt("return");

                case 8:
                  if (openLinksInNewTab) {
                    window.open(action === null || action === void 0 ? void 0 : action.href, "_blank");
                  } else {
                    window.location.href = action === null || action === void 0 ? void 0 : action.href;
                  }

                case 9:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref6.apply(this, arguments);
        };
      }();
    };

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Icon && /*#__PURE__*/_react["default"].createElement(Icon, {
      "data-testid": "message-icon"
    }), /*#__PURE__*/_react["default"].createElement(_styled.Message, {
      "data-testid": "message"
    }, title && /*#__PURE__*/_react["default"].createElement(_styled.Title, {
      "data-testid": "message-title"
    }, title), /*#__PURE__*/_react["default"].createElement(_styled.TextElement, {
      "data-testid": "message-body"
    }, typeof preview === "string" ? /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], {
      options: markdownOptions !== null && markdownOptions !== void 0 ? markdownOptions : _core.defaultMarkdownOptions
    }, preview) : preview), renderActionButtons ? actions === null || actions === void 0 ? void 0 : (_actions$slice = actions.slice(0, 2)) === null || _actions$slice === void 0 ? void 0 : _actions$slice.map(function (action, index) {
      return /*#__PURE__*/_react["default"].createElement(_styled.ActionElement, {
        primary: index === 0,
        backgroundColor: action.background_color,
        key: "".concat(action.href, "-").concat(index),
        onClick: handleActionClick(action)
      }, action.content);
    }) : undefined));
  }, [actions, title, preview]);
  return /*#__PURE__*/_react["default"].createElement(_styled.Container, null, courier.onRouteChange || containerProps.href ? /*#__PURE__*/_react["default"].createElement(ClickableContainer, containerProps, renderedMessage) : /*#__PURE__*/_react["default"].createElement(NonClickableContainer, null, renderedMessage), /*#__PURE__*/_react["default"].createElement(_styled.Dismiss, {
    "data-testid": "dismiss",
    onClick: handleOnClickDismiss
  }, "X"));
};

var _default = Body;
exports["default"] = _default;